"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _getValueFromGenericInput = require("@devsta/get-value-from-generic-input"),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _uiKit = require("@devsta/ui-kit"),
    _validator = require("validator");

require("../styles/_embed-code.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var IFRAME_REGEXP = /^(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))$/gm,
    validateIframe = function validateIframe(embedCode) {
  if (!embedCode) return !1;
  var match = embedCode.match(IFRAME_REGEXP);
  return !!(match && 1 === match.length);
},
    isFormValid = function isFormValid(_ref) {
  var embedCode = _ref.embedCode,
      sourceLink = _ref.sourceLink;
  return validateIframe(embedCode) && (0, _validator.isURL)(sourceLink);
},
    EmbedCodeSource = function (_Component) {
  function EmbedCodeSource(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, EmbedCodeSource), _this = _super.call(this, props), _initialiseProps.call((0, _assertThisInitialized2["default"])(_this));
    var embedCode = props.embedCode,
        sourceLink = props.sourceLink;
    return _this.state = {
      modalVisible: !1,
      embedCode: embedCode || "",
      sourceLink: sourceLink || ""
    }, _this;
  }

  (0, _inherits2["default"])(EmbedCodeSource, _Component);

  var _super = _createSuper(EmbedCodeSource);

  return (0, _createClass2["default"])(EmbedCodeSource, [{
    key: "render",
    value: function render() {
      var children = this.props.children,
          _this$state = this.state,
          modalVisible = _this$state.modalVisible,
          embedCode = _this$state.embedCode,
          sourceLink = _this$state.sourceLink,
          childrenWithProps = _react["default"].cloneElement(children, {
        onClick: this.toggleModal
      });

      return _react["default"].createElement("div", {
        className: "embed-code"
      }, modalVisible && _react["default"].createElement(_uiKit.FormModal, {
        key: "embed-code__modal",
        visible: !0,
        onClose: this.toggleModal,
        onSave: this.handleSave,
        saveDisabled: !isFormValid(this.state),
        title: "Source from Embed Code",
        closeText: "CANCEL"
      }, _react["default"].createElement("div", {
        className: "embed-code__content"
      }, _react["default"].createElement("p", null, "Embed Details"), _react["default"].createElement(_uiKit.Input, {
        id: "embedCode-input",
        label: "embed code*",
        defaultValue: embedCode,
        onChange: this.updateInputField("embedCode"),
        placeholder: "Enter embed code",
        multiline: !0,
        validate: validateIframe,
        errorMessage: "iframe is invalid",
        rows: 3
      }), _react["default"].createElement(_uiKit.Input, {
        id: "sourceLink-input",
        label: "source link*",
        defaultValue: sourceLink,
        onChange: this.updateInputField("sourceLink"),
        placeholder: "Enter source link",
        errorMessage: "This doesn't appear to be a valid url",
        validate: _validator.isURL
      }))), childrenWithProps);
    }
  }]), EmbedCodeSource;
}(_react.Component);

exports["default"] = EmbedCodeSource;

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.updateInputField = (0, _lodash["default"])(function (fieldName) {
    return function (result) {
      _this2.setState((0, _defineProperty2["default"])({}, fieldName, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)));
    };
  }), this.toggleModal = function () {
    _this2.setState(function (_ref2) {
      var modalVisible = _ref2.modalVisible;
      return {
        modalVisible: !modalVisible
      };
    });
  }, this.handleSave = function () {
    var onSave = _this2.props.onSave,
        _this2$state = _this2.state,
        embedCode = _this2$state.embedCode,
        sourceLink = _this2$state.sourceLink;
    onSave({
      embedCode: embedCode,
      sourceLink: sourceLink
    }), _this2.setState({
      embedCode: "",
      sourceLink: ""
    });
  };
};